import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/conversation-inspector/ConversationInspectorResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/api/private/organizations/${e.orgPlaceholder}/agents/search-agent/conversations`;
	}
	getConversationDebug(e) {
		return this.api.get(`${n.baseUrl}/${e}/debug`);
	}
};
//#endregion
export { n as ConversationInspectorResource };

//# sourceMappingURL=ConversationInspectorResource.js.map